export interface TipoEvento {
    idTipoEvento: number,
    estado: string,
    txtNombre: string,
    txtDescripcion: string,
}

export function GetVoidTipoEvento(): TipoEvento {
    return {
        idTipoEvento: 0,
        estado: 'A',
        txtNombre: '',
        txtDescripcion: '',
    }
}